module.exports = __webpack_public_path__ + "static/media/bolt.d4eab336.png";